module.exports = __webpack_public_path__ + "img/IMG_2596-2.14f25ebf.jpg";